import React, { useState, useEffect } from "react";
import "./index.scss";
import {
  pendingServiceInfoHeaderConfig,
  pendingWorkshopManualFormConfig,
  WorkshopHeaderConfig,
} from "./config";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import CustomModal from "../../../core/modal";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import { Box, Button } from "@mui/material";
import { pendingServiceInfoFormConfig } from "./config";
import { getFileNameFromUrl, splitFileName } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownOffAltTwoToneIcon from "@mui/icons-material/ThumbDownOffAltTwoTone";
import moment from "moment";
const PendingWorkshopManuals = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 5,
    approvalStatus: "PENDING",
    sortBy: "-createdAt",
  });
  const [viewForm, setViewForm] = useState({
    isOpen: false,
    data: {},
  });
  const clickHandler = (type, data) => {
    if (type === "VIEW") {
      setViewForm({
        isOpen: true,
        data: {
          ...data,
        },
      });
    }
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results?.map((ele) => {
            return {
              ...ele,
              oem: ele.oem.name,
              releasedOn: moment(ele.releasedOn).format("DD-MM-YYYY"),
            };
          });
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const updateFormStatus = (status, item) => {
    const { id } = viewForm.data;

    if (id) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}/approve-revision`,
        null,
        {
          approvalStatus: status,
          workshopId: id,
        }
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Updated Sucessfully");
            setViewForm({
              isOpen: false,
              data: {},
            });
            loadData(filters);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Pending Requests</p>
        <p className="section-name">Workshop Manuals</p>
      </div>
      <div className="si-hide-mobile">
        <CustomTable
          header={WorkshopHeaderConfig(data.results || [])}
          data={data.results || []}
          pageCount={data.totalPages}
          onClick={clickHandler}
          filters={filters}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            loadData({
              ...filters,
              page,
            });
          }}
          isLoading={isLoading}
        />
      </div>

      {viewForm?.isOpen && (
        <CustomModal
          title="Workshop Manuals"
          onClose={() => {
            setViewForm({
              isOpen: false,
              data: {},
            });
          }}
          contentClassName="pending-model"
        >
          {viewForm?.data?.approvalStatus === "PENDING" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 1,
              }}
            >
              <Button
                variant="contained"
                color="success"
                sx={{ mr: 1, borderRadius: "0px" }}
                size="small"
                onClick={() => updateFormStatus("APPROVED", viewForm?.data)}
                startIcon={<ThumbUpAltTwoToneIcon />}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{ ml: 1, mr: 3, borderRadius: "0px" }}
                size="small"
                onClick={() => updateFormStatus("REJECTED", viewForm?.data)}
                startIcon={<ThumbDownOffAltTwoToneIcon />}
              >
                Reject
              </Button>
            </Box>
          )}
          <PreviewFormGenerator
            formConfig={pendingWorkshopManualFormConfig()}
            formValues={viewForm.data}
          />
          <p>Document</p>
          {viewForm?.data?.document && (
            <a
              className="file-name"
              href={splitFileName(viewForm.data.document)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getFileNameFromUrl(viewForm.data.document, 50)}
            </a>
          )}
        </CustomModal>
      )}
    </div>
  );
};

export default PendingWorkshopManuals;
